/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';

import Input from '~/components/Input';
import api from '~/services/api';
import history from '~/services/history';
import { Container, Row, Header, ButtonTest } from './styles';

export default function Tutoria() {
  const formRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [disciples, setDisciples] = useState([]);
  const [relations, setRelations] = useState([]);
  // const [feedback, setFeedback] = useState('');

  useEffect(() => {
    async function getDataStudents() {
      const { data } = await api.get('/student/tutorings');
      setUsers(data);
    }

    async function getDataDisciples() {
      const { data } = await api.get('/student/disciples');
      setDisciples(data);
    }

    async function getDataRelations() {
      const { data } = await api.get('/tutorings');
      setRelations(data);
    }

    getDataStudents();
    getDataDisciples();
    getDataRelations();
  }, []);

  // const handleInputChange = e => {
  //   const { value } = e.target;
  //   setFeedback(value);
  // };

  async function handleSubmit(data, { reset }) {
    const { email_tutor, email_student } = data;

    if (email_tutor && email_student) {
      await api.post('/tutorings', data);
      reset();
      return toast.success('Tutor cadastrado com sucesso');
    }
    return toast.error('Preencha todos os campos');
  }

  return (
    <>
      <Header>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorChallenge')}
        >
          <h2>Desafios</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/educatorJobs')}>
          <h2>Vagas</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorTutoria')}
          selected
        >
          <h2>Tutoria</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorUsers')}
        >
          <h2>Usuários</h2>
        </ButtonTest>
      </Header>
      <Container>
        <h2>Cadastrar Tutoria</h2>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <div className="support">
            <Input
              name="email_tutor"
              type="text"
              placeholder="E-mail do Tutor"
            />
            <Input
              name="email_student"
              type="text"
              placeholder="E-mail do Estudante"
            />
          </div>
          <button className="form" type="submit">
            SALVAR
          </button>
        </Form>

        <h1>Tutoria dos Alunos</h1>
        {relations.map(relation => (
          <Row key={relation.id}>
            <p>Tutor: {relation.email_tutor}</p>
            <p>Estudante: {relation.email_student}</p>
          </Row>
        ))}

        <h2>Lista de Tutores ({users.length}):</h2>
        {users.map(user => (
          <Row key={user.id}>
            <p>ID: {user.id}</p>
            <p>
              Aluno: {user.first_name} {user.last_name}
            </p>
            <p>Email: {user.email}</p>
            <p>Nivel de Programaçāo: {user.level}</p>
            <p>Nivel de Inglês: {user.english}</p>
            <p>Entrou na plataforma: {user.created_at}</p>
          </Row>
        ))}

        <h2>Lista de Discipulos ({disciples.length}):</h2>
        {disciples.map(user => (
          <Row key={user.id}>
            <p>ID: {user.id}</p>
            <p>
              Aluno: {user.first_name} {user.last_name}
            </p>
            <p>Email: {user.email}</p>
            <p>Nivel de Programaçāo: {user.level}</p>
            <p>Nivel de Inglês: {user.english}</p>
            <p>Entrou na plataforma: {user.created_at}</p>
          </Row>
        ))}
      </Container>
    </>
  );
}
